<div class="MainContainer" style="padding-bottom: 2%;">

  <div class="ETransportStepOneContainer animated fadeInDown" *ngIf="ShowETransportStepOne">
    <div class="ETransportStepOneTitle">
      <p>{{'GenerateUITTitle' | translate}} [{{this.UITShippingCompany?.Name}}]</p>
      <i class="material-icons" (click)="ShowETransportStepOne = false;">close</i>
    </div>
    <div class="ETransportStepOneBody">
      <div class="ETransportStepOneBodyRow">
        <div class="PopUpBodyOneThirddContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportCustomsStation' | translate }}</mat-label>
             <mat-select name="ETransportCustomsStation" [compareWith]="compareFn" [(ngModel)]="ETransportCustomsStation">
              <mat-option *ngFor="let a of this.CustomsStations;" [value]="a">
                 {{a.Name}}
               </mat-option>
             </mat-select>
            </mat-form-field>
          </div>
           
          <div class="PopUpBodyTwoThirdsContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'ETransportDocumentType' | translate }}</mat-label>
               <mat-select name="ETransportDocumentType" [compareWith]="compareFn" [(ngModel)]="ETransportDocumentType">
                <mat-option *ngFor="let a of this.ETransportDocumentTypes;" [value]="a">
                   {{a.Name}}
                 </mat-option>
               </mat-select>
              </mat-form-field>
          </div>
      </div>
  
      <div class="ETransportStepOneBodyRow">
        <div class="PopUpBodyOneThirddContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportMeasuringUnit' | translate }}</mat-label>
             <mat-select name="ETransportMeasuringUnit" [compareWith]="compareFn" [(ngModel)]="ETransportMeasuringUnit">
              <mat-option *ngFor="let a of this.ETransportMeasuringUnits;" [value]="a">
                 {{a.Name}}
               </mat-option>
             </mat-select>
            </mat-form-field>
          </div>
           
          <div class="PopUpBodyTwoThirdsContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'ETransportOperationReason' | translate }}</mat-label>
               <mat-select name="ETransportOperationReason" [compareWith]="compareFn" [(ngModel)]="ETransportOperationReason">
                <mat-option *ngFor="let a of this.ETransportOperationReasons;" [value]="a">
                   {{a.Name}}
                 </mat-option>
               </mat-select>
              </mat-form-field>
          </div>
      </div>
  
      <div class="ETransportStepOneBodyRow">
        <div class="PopUpBodyOneThirddContainer">
          <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
            <mat-label>{{ 'AutoPlatesNumber' | translate }}</mat-label>
            <input matInput placeholder="{{ 'AutoPlatesNumber' | translate }}" autocomplete="off" [(ngModel)]="UITAutoPlatesNumber">
          </mat-form-field>
        </div>
           
          <div class="PopUpBodyTwoThirdsContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'ETransportOperationType' | translate }}</mat-label>
               <mat-select name="ETransportOperationType" [compareWith]="compareFn" [(ngModel)]="ETransportOperationType">
                <mat-option *ngFor="let a of this.ETransportOperationTypes;" [value]="a">
                   [{{a.Name}}] {{a.Description}}
                 </mat-option>
               </mat-select>
              </mat-form-field>
          </div>
      </div>
  
      <div class="ETransportStepOneBodyRow">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: 95%;">
          <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
           <mat-select name="ETransportOperationType" [compareWith]="compareFn" [(ngModel)]="UITShippingCompany">
            <mat-option *ngFor="let s of this.ShippingCompanies;" [value]="s">
               {{s.Name}}
             </mat-option>
           </mat-select>
          </mat-form-field>
      </div>
  
      <div class="ETransportStepOneBodyRow" *ngIf="this.ETransportOperationType.ID == 40 || this.ETransportOperationType.ID == 50">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: 95%;">
          <mat-label>{{ 'ETransportCustomsBureau' | translate }}</mat-label>
           <mat-select name="ETransportCustomsBureau" [compareWith]="compareFn" [(ngModel)]="ETransportCustomsBureau">
            <mat-option *ngFor="let s of this.ETransportCustomsBureaus;" [value]="s">
               {{s.Name}}
             </mat-option>
           </mat-select>
          </mat-form-field>
      </div>
      
      <div class="ETransportStepOneBodyRow">
        <mat-form-field class="PartnerInput" appearance="outline" style="width: 95%;">
          <mat-label>{{ 'TotalShipmentValueRONNoVAT' | translate }}</mat-label>
          <input matInput placeholder="{{'TotalShipmentValueRONNoVAT' | translate}}"
          [(ngModel)]="this.TotalShipmentValueRONNoVAT">
        </mat-form-field>
      </div>

      <div class="ETransportStepOneBodyRow">
        <mat-form-field class="PartnerInput" appearance="outline" style="width: 95%;">
          <mat-label>{{ 'ShipmentWeightKGs' | translate }}</mat-label>
          <input matInput placeholder="{{'ShipmentWeightKGs' | translate}}"
          [(ngModel)]="this.ShipmentWeightKGs">
        </mat-form-field>
      </div>

      <div class="ETransportStepOneBodyRow">
        <mat-form-field class="PartnerInput" appearance="outline" style="width: 95%;">
          <mat-label>{{ 'DocumentNumber' | translate }}</mat-label>
          <input matInput placeholder="{{'DocumentNumber' | translate}}"
          [(ngModel)]="this.DocumentNumber">
        </mat-form-field>
      </div>

    </div>
    <div class="ETransportStepOneCommands">
      <button mat-raised-button color="accent" class="FilterButtonAction" [disabled]="!DocumentNumber || !ShipmentWeightKGs || !TotalShipmentValueRONNoVAT || DocumentBodyLoading == true" (click)="GenerateUIT();">{{ 'GenerateUIT' | translate }}</button>
    </div>
  </div>

  <div class="ETransportStepOneContainer animated fadeInDown" *ngIf="ShowETransportDetails">
    <div class="ETransportStepOneTitle">
      <p>{{'GenerateUITTitle' | translate}} [{{this.UITShippingCompany?.Name}}]</p>
      <i class="material-icons" (click)="ShowETransportDetails = false;">close</i>
    </div>
    <div class="ETransportStepOneBody">
        <div class="ETransportStatus">
          {{'Status' | translate}}: {{this.ETransportDetails.Status.Name}}
        </div>
        <div class="ETransportErrorMessage" *ngIf="this.ETransportDetails?.ETransportErrorMessage?.length > 0;">
          {{'ErrorMessage' | translate}}: {{this.ETransportDetails.ETransportErrorMessage}}
        </div>
        <div class="ETransportUploadID">
          {{'UploadID' | translate}} {{this.ETransportDetails.ETransportUploadID}}
        </div>
        <div class="ETransportUploadID">
          {{'UIT' | translate}}: {{this.ETransportDetails.ETransportUIT}}
        </div>
    </div>
    <div class="ETransportStepOneCommands">
      <button mat-raised-button color="accent" class="FilterButtonAction" (click)="CloseUIT();">{{ 'OK' | translate }}</button>
    </div>
  </div>

  <div class="ETransportStepOneContainer animated fadeInDown" *ngIf="ShowETransportStepZero">
    <div class="ETransportStepOneTitle">
      <p>{{'GenerateUITTitle' | translate}} [{{this.UITShippingCompany?.Name}}]</p>
      <i class="material-icons" (click)="ShowETransportStepZero = false;">close</i>
    </div>
    <div class="ETransportStepOneBody">
      <div class="AddNewCompanyContainerBodyRow">
        <mat-form-field class="PartnerInput" appearance="outline" style="width: 95%;">
          <mat-label>{{ 'AssociatedPartner' | translate }}</mat-label>
            <i style="border: none;" class="material-icons PartnerInputIcon" *ngIf="!(this.PartnersFilter?.SearchTerm?.length > 0);">search</i>
            <i style="border: none;color: red;cursor: pointer;" class="material-icons PartnerInputIcon" *ngIf="this.PartnersFilter?.SearchTerm?.length > 0;" (click)="ResetPartnersSearch();">close</i>
          <input matInput placeholder="{{'AssociatedPartner' | translate}}"
          [(ngModel)]="this.PartnersFilter.SearchTerm"
          (ngModelChange)="this.partnerSearchTermUpdate.next($event)">
        </mat-form-field>
        <div class="AssiciatedPartnerResultsContainer" *ngIf="this.Partners?.length > 0;" style="max-height: 226px;overflow-y: auto;width: 95%;">
          <div class="PartnerResult" *ngFor="let p of this.Partners" (click)="ChoosePartnerNewUIT(p);">
            {{p.Name}} {{'VAT' | translate}}: {{p.VAT}}
          </div>
        </div>
      </div>
      <div class="ETransportStepOneBodyRow">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: 95%;">
          <mat-label>{{ 'GeneralDocType' | translate }}</mat-label>
           <mat-select name="GeneralDocType" [compareWith]="compareFn" [(ngModel)]="GeneralDocType">
            <mat-option *ngFor="let s of this.GeneralDocTypes;" [value]="s">
               {{s.Name}}
             </mat-option>
           </mat-select>
          </mat-form-field>
      </div>
    </div>
    <div class="ETransportStepOneCommands">
      <button mat-raised-button color="accent" [disabled]="!UITPartner || !GeneralDocType" class="FilterButtonAction" (click)="this.ShowETransportStepZero = false; PrepareETransportStep1(this.UITPartner);">{{ 'NextStep' | translate }}</button>
    </div>
  </div>

    <div class="ShippingComapniesContainer">

        <div class="AddNewCompanyContainer" *ngIf="ShowOpenNewTransporterPopUp == true;">
          <div class="AddNewCompanyContainerTitle">
            <i (click)="this.ShowOpenNewTransporterPopUp = false;" class="material-icons">close</i>
            <p>{{'AddNewShippingCompany' | translate}}</p>
          </div>
          <div class="AddNewCompanyContainerBody">
            <div class="AddNewCompanyContainerBodyRow">
              <mat-form-field class="ReceptionExchangeInput" appearance="outline">
                <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
                <input [(ngModel)]="NewShippingCompany.Name" matInput placeholder="{{'ShippingCompany' | translate}}">
              </mat-form-field>
            </div>
            <div class="AddNewCompanyContainerBodyRow">
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>{{ 'TransporterType' | translate }}</mat-label>
                <mat-select name="TransporterType" [compareWith]="compareFn" [(ngModel)]="NewShippingCompany.Category">
                  <mat-option *ngFor="let c of this.MasterData.Categories" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="AddNewCompanyContainerBodyRow">
              <mat-form-field class="PartnerInput" appearance="outline" style="width: 100%;">
                <mat-label>{{ 'AssociatedPartner' | translate }}</mat-label>
                <i style="border: none;" class="material-icons PartnerInputIcon" *ngIf="!(this.PartnersFilter?.SearchTerm?.length > 0);">search</i>
                <i style="border: none;color: red;cursor: pointer;" class="material-icons PartnerInputIcon" *ngIf="this.PartnersFilter?.SearchTerm?.length > 0;" (click)="ResetPartnersSearch();">close</i>
                <input matInput placeholder="{{'AssociatedPartner' | translate}}"
                [(ngModel)]="this.PartnersFilter.SearchTerm"
                (ngModelChange)="this.partnerSearchTermUpdate.next($event)">
              </mat-form-field>
              <div class="AssiciatedPartnerResultsContainer" *ngIf="this.Partners?.length > 0;" style="max-height: 226px;overflow-y: auto;width: 100%;">
                <div class="PartnerResult" *ngFor="let p of this.Partners" (click)="ChoosePartnerNewTransporter(p);">
                  {{p.Name}} {{'VAT' | translate}}: {{p.VAT}}
                </div>
              </div>
            </div>

            <div class="AddNewCompanyContainerBodyRow" style="padding: 20px;">
              <p>{{'ShippingServiceType' | translate}}</p>
              <mat-checkbox class="AddNewCompanyContainerBodyRow" *ngFor="let type of this.NewShippingCompany.ShippingServiceTypes" [(ngModel)]="type.IsSelected">{{type.Name}}</mat-checkbox>
            </div>

          </div>
          <div class="AddNewCompanyContainerCommands">
            <button class="InvoiceVerificationButton" mat-stroked-button style="background: #0082e6;color: #fff; padding-left: 15px;width: 95%;" (click)="AddUpdateShippingCompanyWithDetails();">
              <i class="material-icons">add</i>
              <span>{{'AddNewShippingCompany' | translate}}</span>
            </button>
          </div>
        </div>

        <div class="overlay" *ngIf="EFacturaStepOne == true || ShowOpenNewTransporterPopUp == true;"></div>
        
        <div class="EFacturaStepOne animated fadeInDown" *ngIf="this.EFacturaStepOne == true;">
            <!-- <div class="EFacturaStepBack">
                <i class="material-icons">arrow_back_ios_new</i>
            </div> -->
            <div class="EFacturaStepClose" (click)="this.EFacturaStepOne = false;">
                <i class="material-icons">close</i>
            </div>
            <div class="EFacturaStepTitle">
                {{'CheckTransportCosts' | translate}}
            </div>
            <div class="EFacturaStepBody">
              <div class="EFacturaStepBodyTitle">
                {{'ChooseEFacturaPeriod' | translate}}
              </div>
            
              <div class="EFacturaStepOneRow">
                <mat-form-field appearance="outline" class="ReceptionProductsColDropDown" style="width: 95%;">
                  <mat-label>{{ 'VATNumber' | translate }}*</mat-label>
                  <input disabled="true" matInput placeholder="{{ 'VATNumber' | translate }}*" autocomplete="off" [(ngModel)]="EFacturaFilter.VATNumber">
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="EFacturaStepOneDateTimePicker">
                  <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
                  <input matInput [matDatepicker]="dp2" [formControl]="EFacturaFromDate"
                         [min]="minDate" [max]="maxDate" [(ngModel)]="EFacturaFilter.FromDate" 
                         (dateChange)="ClearPeriod()">
                  <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                  <mat-datepicker #dp2></mat-datepicker>
                </mat-form-field>
          
                <mat-form-field appearance="outline" class="EFacturaStepOneDateTimePicker">
                  <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
                  <input matInput [matDatepicker]="dp3" [formControl]="EFacturaToDate"
                         [min]="minDate" [max]="maxDate" [(ngModel)]="EFacturaFilter.ToDate" 
                         (dateChange)="ClearPeriod()">
                  <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                  <mat-datepicker #dp3></mat-datepicker>
                </mat-form-field>
          
                <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.loadingEFacturaDocuments == true"></mat-spinner>
              </div>
           
            </div>
            <div class="EFacturaStepCommand">
                <button mat-flat-button color="primary" [disabled]="this.loadingEFacturaDocuments == true" (click)="AllocateTransportationCostsOnDocuments();">
                  {{'CheckTransportCosts' | translate}}
                  <i class="material-icons">navigate_next</i>
                </button>
            </div>
          </div>

        <div class="MainTitleBar" style="overflow: unset;">
            <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
                <i class="material-icons">filter_alt</i>
                <span>{{'Filter' | translate}}</span>
            </div>
        
            <div class="ActiveFiltersContainer">
              <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
                {{a.Name}}
                <i class="material-icons">close</i>
              </div>
            </div>
        
            <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
                <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                    <i class="material-icons">close</i>
                </div>
        
                <div class="FilterContainerBody">
        
                    <div class="PopUpBodyRow">
                    </div>
        
                    <div class="PopUpBodyTwoThirdsContainer">
                        <mat-form-field style="width: 100%;" appearance="outline">
                            <mat-label>{{ 'TransporterType' | translate }}</mat-label>
                            <mat-select name="TransporterType" [compareWith]="compareFn" [(ngModel)]="this.Filter.InvoiceDocType">
                              <mat-option *ngFor="let c of this.MasterData.Categories" [value]="c" (click)="AddActiveFilter(c.Name, 'InvoiceDocType');">
                                {{c.Name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                    </div>
                     
                    <div class="PopUpBodyOneThirddContainer">
                       
                    </div>
                    
                    <div class="PopUpBodyTwoThirdsContainer">
                       
                    </div>
    
                    <div class="PopUpBodyTwoThirdsContainer">
                     
                    </div>
    
                    <div class="PopUpBodyOneThirddContainer">
                   
                    </div>
                </div>
                
                <div class="FilterCommands">
                    <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetShippingCompaniesFullData();">{{ 'FilterInvoices' | translate }}</button>
                </div>
            </div>
    
            <div class="TotalDocCountContainer">
              <span style="float: right;">{{this.ShippingCompanies?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'ShippingCompanies' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
              <div class="PageSizeContainer">
                <mat-form-field appearance="outline" class="PageSizeTextBox">
                  <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                  <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetShippingCompaniesFullData(1);">
                </mat-form-field>
              </div>
            </div>
    
            <div class="TotalDocCountContainer">
              <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetShippingCompaniesFullData(this.Filter.Pager.PageIndex - 1);">
                <i class="material-icons">chevron_left</i>
              </div>
              <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_left</i>
              </div>
    
              <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetShippingCompaniesFullData(this.Filter.Pager.PageIndex + 1);">
                <i class="material-icons">chevron_right</i>
              </div>
              <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_right</i>
              </div>
            </div>
        </div>
        
        <div class="MainTitleBar" style="overflow: unset; width: 25%;">
            <input placeholder="{{ 'Search' | translate }}" type="text" class="MainTransporterSearch" [(ngModel)]="Filter.Product" (change)="GetShippingCompaniesFullData(); AddActiveFilter(Filter.Product, 'Product');">
            <i class="material-icons MainTransporterSearchIcon" (click)="GetShippingCompaniesFullData(); AddActiveFilter(Filter.Product, 'Product');" *ngIf="!(Filter.Product?.length > 0);">search</i>
            <i style="color: red;cursor: pointer;" class="material-icons MainTransporterSearchIcon" (click)="Filter.Product = ''; GetShippingCompaniesFullData(); AddActiveFilter(Filter.Product, 'Product');" *ngIf="(Filter.Product?.length > 0);">close</i>
        </div>

        <div class="ShippingCompanyHeadder">
            <div class="ShippingCompanyRow">
                <div class="ShippingCompanyRowInformationColumn" style="width: 5%;">
                    #
                </div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 10%;">
                    {{'Logo' | translate}}
                </div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 15%;">{{'ShippingCompany' | translate}}</div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 24%;"></div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 15%;">{{'TransporterType' | translate}}</div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 25%;">
                </div>
            </div>
        </div>
        <div class="ShippingCompany" *ngFor="let s of this.ShippingCompanies; let i = index;">
            <div class="ShippingCompanyRow">
                <div class="ShippingCompanyRowInformationColumn" style="width: 5%;">
                    {{i+1}}
                </div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 10%;">
                    <img class="ShippingCompanyImage" *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" />
                </div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 25%;">
                    <span *ngIf="s.IsSelected == false;">{{s.Name}}</span>
                    <mat-form-field class="ReceptionExchangeInput" *ngIf="s.IsSelected == true;" appearance="outline">
                        <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
                        <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
                        <input [(ngModel)]="s.Name" matInput placeholder="{{'ShippingCompany' | translate}}">
                    </mat-form-field>
                </div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 14%;"></div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 15%;">
                    <span *ngIf="s.IsSelected == false;">{{s.Category?.Name}}</span>
                      <mat-form-field style="width: 100%;" appearance="outline" *ngIf="s.IsSelected == true;">
                        <mat-label>{{ 'TransporterType' | translate }}</mat-label>
                        <mat-select name="TransporterType" [compareWith]="compareFn" [(ngModel)]="s.Category">
                          <mat-option *ngFor="let c of this.MasterData.Categories" [value]="c">
                            {{c.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                <div class="ShippingCompanyRowInformationColumn" style="width: 25%;">
                    <i class="material-icons" *ngIf="s.IsSelected == false;" (click)="SelectShippingCompany(s);">keyboard_arrow_down</i>
                    <i class="material-icons" *ngIf="s.IsSelected == true;" (click)="SelectShippingCompany(s);">keyboard_arrow_up</i>
                </div>
            </div>
            <div class="ShippingCompanyBody" *ngIf="s.IsSelected == true;">
                <div *ngIf="this.bodyLoading != true;">
                    <div class="ShippingCompanyBodyTitle">{{'ShippingCompanySupportContacts' | translate}}</div>
                <div class="SupportContactsGroup" *ngFor="let sc of s.SupportContacts">
                    <span (click)="SelectEmailSupportCategory(sc, s);">{{sc.Category?.Name}}</span>
                    <i (click)="SelectEmailSupportCategory(sc, s);" class="material-icons" *ngIf="sc.IsSelected != true;">keyboard_arrow_down</i>
                    <i (click)="SelectEmailSupportCategory(sc, s);" class="material-icons" *ngIf="sc.IsSelected == true;">keyboard_arrow_up</i>

                    <div class="SupportContactsGroupBody" *ngIf="sc.IsSelected == true;">
                        <div class="SupportEmail" *ngFor="let e of sc.Emails">
                            <span>{{e.Email}}</span>
                            <i class="material-icons" (click)="DeleteShippingCompanySupportEmail(e.ID, sc, e);">close</i>
                        </div>

                        <div class="SupportEmail">
                            <span>
                                <input type="text" class="SupportEmailAddTextBox" [(ngModel)]="NewEmailSupportCategory.Email">
                            </span>
                            <i class="material-icons" style="color: #0082e6;" (click)="AddEmailToSupportCategory(sc.Category.ID, s.ID);">add</i>
                        </div>
                    </div>
                </div>

                <div class="ShippingCompanyBodyTitle">
                    <span>{{'AssociatedPartner' | translate}}</span>
                    <span *ngIf="s.Partner?.ID?.length > 0;">: {{s.Partner?.Name}} ({{'VAT' | translate}}: {{s.Partner.VAT}})</span>
                    <i *ngIf="s.Partner?.ID?.length > 0;" class="material-icons">verified_user</i>
                </div>

                <div class="UITGeneratorContainer">
                  <button class="ShippingUpdateButton" mat-flat-button color="primary" style="margin: 0;" (click)="PrepareETransportStep0(s);">
                    <div *ngIf="loadingUIT != true;">
                     <i class="material-icons">check</i>
                     <span>{{'GenerateUIT' | translate}}</span>
                    </div>
                    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="loadingUIT == true;"></mat-spinner>
                 </button>
                </div>

                <div class="fullRow">
                    <mat-form-field class="PartnerInput" *ngIf="s.IsSelected == true;" appearance="outline">
                        <mat-label>{{ 'AssociatedPartner' | translate }}</mat-label>
                        <i style="border: none;" class="material-icons PartnerInputIcon" *ngIf="!(this.PartnersFilter?.SearchTerm?.length > 0);">search</i>
                        <i style="border: none;color: red;cursor: pointer;" class="material-icons PartnerInputIcon" *ngIf="this.PartnersFilter?.SearchTerm?.length > 0;" (click)="ResetPartnersSearch();">close</i>
                        <input matInput placeholder="{{'AssociatedPartner' | translate}}"
                        [(ngModel)]="this.PartnersFilter.SearchTerm"
                        (ngModelChange)="this.partnerSearchTermUpdate.next($event)">
                    </mat-form-field>
                    <div class="AssiciatedPartnerResultsContainer" *ngIf="this.Partners?.length > 0;">
                        <div class="PartnerResult" *ngFor="let p of this.Partners" (click)="ChoosePartner(p, s);">
                            {{p.Name}} {{'VAT' | translate}}: {{p.VAT}}
                        </div>
                    </div>
                    <div class="ROANCOMAuthorizedSlide">
                      <mat-slide-toggle matTooltip="{{'ROANCOMAuthorizedDescription' | translate}}" matTooltipClass='neutral-tool-tip' [(ngModel)]="s.ROANCOMAuthorized">{{'ROANCOMAuthorized' | translate}}</mat-slide-toggle>
                    </div>
                  </div>
                </div>
                <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.bodyLoading == true;"></mat-spinner>
            </div>
            <div class="ShippingCompanyCommands" *ngIf="s.IsSelected == true && this.bodyLoading == false;">
                <button class="ShippingUpdateButton" mat-stroked-button (click)="AddUpdateShippingCompany(s);">
                   <div *ngIf="loadingShippingCompanyUpdate != true;">
                    <i class="material-icons">check</i>
                    <span>{{'Update' | translate}}</span>
                   </div>
                   <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="loadingShippingCompanyUpdate == true;"></mat-spinner>
                </button>

                <button class="InvoiceVerificationButton" mat-stroked-button style="background: #0082e6;color: #fff;" (click)="PrepareForTransportationCostsEFactura(s);">
                    <div *ngIf="loadingShippingCompanyUpdate != true;">
                     <i class="material-icons">check</i>
                     <span>{{'CheckInvoicesTransportationCosts' | translate}}</span>
                    </div>
                    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="loadingShippingCompanyUpdate == true;"></mat-spinner>
                </button>
            </div>
        </div>

        <div class="ShippingCompany">
          <div class="ShippingCompanyRow"></div>
          <div class="ShippingCompanyCommands">
            <button class="InvoiceVerificationButton" mat-stroked-button style="background: #0082e6;color: #fff; padding-left: 15px;" (click)="OpenNewTransporterPopUp();">
               <i class="material-icons">add</i>
               <span>{{'AddNewShippingCompany' | translate}}</span>
          </button>
          </div>
        </div>
    </div>
</div>
